import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Template from "../../template/Template";
import TableDataSimple from "../../components/Tables/TableDataSimple";
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api } from '../../services/api';
import isPermission from '../../services/permission';

export default function Funcionarios() {
    const [infoLogin] = useState(JSON.parse(sessionStorage.getItem('infoLogin')));
    const [openLoad, setOpenLoad] = useState(false);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const columns = [
        {
            id: 'nome_funcionario',
            numeric: false,
            label: 'NOME FUNCIONARIO(A)',
        },
        {
            id: 'telefone_1',
            numeric: false,
            disablePadding: false,
            label: 'TELEFONE 1',
        },
        {
            id: 'cargo_funcionario',
            numeric: false,
            disablePadding: false,
            label: 'CARGO',
        }
    ];

    function handleClick(row) {
        if(isPermission(13) && row.id_funcionario){
            navigate(`/cadastrofuncionario?id=${row.id_funcionario}`);
        }
    }

    async function loadData() {
        setOpenLoad(true);
        const id_escola_funcionario = infoLogin.id_escola_usuario;
        try {
            const response = await api.post(`/funcionarios`, {id_escola_funcionario});
            if(response && response.status === 200 && response.data){
                if(response.data.error) AlertInfo("error", response.data.message);
                else setRows(response.data);
            }
        } catch (error) {
            console.log(error);
            AlertInfo("error", 'NÃO POSSIVEL BUSCAR DADOS');
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, []);

    return(
        <Template menuActive="funcionarios">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={2}>
                    {isPermission(6) && (
                        <Link to="/cadastrofuncionario">
                            <Button 
                                variant="contained"
                                fullWidth
                            >
                                NOVO FUNCIONARIO(A)
                            </Button>
                        </Link>
                    )}
                </Grid>
                <Grid item xs={12}>
                    <TableDataSimple
                        label="Lista de Funcionarios"
                        rows={rows}
                        columns={columns} 
                        handleClick={handleClick}
                    />
                </Grid>
            </Grid>

            <SimpleBackdrop open={openLoad} />
        </Template>
    );
}